<template>
<div>
    <headerNav title="下级充值单据" />
    <van-sticky>
        <!-- <van-search v-model="iptvalue" @search="onSearch" placeholder="请输入充值单号后按下回车" /> -->
        <van-cell title="选择订单时间"  :value="date" @click="show = true" />
    </van-sticky>
    <van-calendar v-model="show" :min-date="minDate"  type="range" @confirm="onConfirm" />
    <div>
        <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky offset-top="44">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
                    <van-list v-model="navitem.loaded" :finished="navitem.loadingType=='nomore'?true:false" :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'" @load="loadData">
                        <div v-for="(item,index) in navitem.List" class="mian-list" @click="detail(item)" :key="index">

                            <div class="mian-list-info">
                                <div class="mian-list-pic">
                                    <img v-lazy="$baseurl+item.proofPath">
                                </div>

                                <div class="main-list-info-main">
                                    <div class="mian-list-info-data min-height">
                                        <van-tag type="primary" class="mian-list-info-left-tag" v-if="item.productType==1" size="medium">大货</van-tag>
                                        <van-tag type="primary" class="mian-list-info-left-tag" v-if="item.productType==2" size="medium">物料</van-tag>
                                        <van-tag type="primary" v-if="item.isAudit==0" size="medium" class="mian-list-info-right-tag">{{item.isTransferOrder?'已转单':'待审核'}}</van-tag>

                                        <van-tag type="success" class="mian-list-info-right-tag" v-if="item.isAudit==1" size="medium">已通过</van-tag>
                                        <van-tag type="danger" class="mian-list-info-right-tag" v-if="item.isAudit==2" size="medium">已取消</van-tag>
                                    </div>

                                    <div class="mian-list-info-data">
                                        <span>充值金额:</span>
                                        <span>{{item.money}}</span>
                                    </div>

                                    <!-- <div class="mian-list-info-data">
                                  <span>这行数据不知道什么</span>
                                  <span class="mian-list-info-right">2020-09-24</span>
                                </div> -->
                                    <div class="mian-list-info-data">
                                        <span>流水单号:</span>
                                        <span>{{item.tid}}</span>
                                    </div>
                                    <div class="mian-list-info-data">
                                        <span>分销商:</span>
                                        <div v-html="item.dealerName"></div>
                                        <!-- <span>{{item.dealerName}}</span> -->
                                    </div>
                                    <div class="mian-list-info-data-last">
                                        {{item.creationTime}}
                                    </div>
                                </div>

                            </div>
                            <div class="mian-list-mark" v-if="item.comment">
                                <div>备注:{{item.comment}}</div>
                            </div>
                            <div style="text-align:center" class="mian-list-btns" v-if="item.isAudit==0 && !item.isTransferOrder">
                                <van-button type="primary"  @click.stop="auditRecharge(0,item)">转单上级</van-button>
                                <!--<van-button type="info" @click.stop="auditRecharge(1,item)">划拨余额</van-button>-->
                                <van-button type="danger"  @click.stop="auditRecharge(2,item)">取消订单</van-button>
                            </div>
                        </div>
                    </van-list>
                </van-tab>
            </van-pull-refresh>
        </van-tabs>
    </div>
    <van-popup v-model="popshow">
        <div class="info mz-proof">
            <div class="mz-proof-upload">
                <div class="mz-proof-upload">
                    <van-uploader upload-text="上传凭据" v-model="fileList" :max-count="1" :after-read="afterRead" accept="image/*">
                    </van-uploader>
                </div>
            </div>
        </div>
        <div class="mz-proof-btns">
            <van-button @click="Recharge()" round type="primary">转单上级</van-button>
        </div>
    </van-popup>
    <!-- <div style="overflow-y:scroll;height:600px">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="item in list" :key="item.id" @click="detail(item)">
            <div slot="title">充值金额: {{item.money}}</div>
            <div slot="default">
              <van-tag
                type="primary"
                v-if="item.isAudit==0"
                size="medium"
              >{{item.isTransferOrder?'已转单':'待审核'}}</van-tag>
              <van-tag type="success" v-if="item.isAudit==1" size="medium">已通过</van-tag>
              <van-tag type="danger" v-if="item.isAudit==2" size="medium">已取消</van-tag>
            </div>
            <div slot="label" style="width:220px" >
              充值单号:{{item.tid}} 
              <br />  
              分销商:{{item.dealerName}}  
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div> -->
</div>
</template>

<script>
export default {
    data() {
        return {
            date: "",
            popshow: false,
            show: false,
             minDate: new Date(2020, 0, 1),
             maxDate: new Date(),
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            fileList: [],
            pageParams: {
                maxResultCount: 8,
                skipCount: 0,
            },
            totalCount: 0,
            tabCurrentIndex: 0,
            navList: [{
                    state: 0,
                    text: '全部',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    List: []
                },
                {
                    state: 1,
                    text: '待处理',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "isAudit": 0,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    List: []
                },
                {
                    state: 2,
                    text: '已处理',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "isAudit": 1,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    List: []
                }
            ],
            starttime: undefined,
            endtime: undefined,
            iptvalue: undefined,
            curitem: {},
            curproofpath: ''
        };
    },
    created() {
        this.abp.event.on("app.AuditRechargeRecord", (x) => {
            console.log(x);
            if (x.status != 0) {
                this.$dialog({
                    message: x.errMsg
                });
            } else {
                this.$toast.success(x.result);
                this.loadData('refresh');
            }
        });
        this.abp.event.on("app.AuditAssist", (x) => {
            if (x.status != 0) {
                this.$dialog({
                    message: x.errMsg
                });
            } else {
                this.$toast.success(x.result);
                this.loadData('refresh');
            }
        });

    },
    methods: {
        auditRecharge(e, item) {

            //转上级需要凭证
            if (e == 0) {
                this.curitem = item;
                this.curproofpath = '';
                this.fileList = [];
                this.popshow = true;
            } else {
                this.tj(e, item);
            }
        },
        tj(e, item, filepath = '') {

            this.ajax
                .post("/api/services/app/PhoneUser/AuditRecharge", {
                    id: item.id,
                    status: e,
                    proofPath: filepath
                })
                .then(() => {
                    //this.$toast.loading("正在执行中");
                    this.popshow = false;
                });
        },
        afterRead(file) {
            var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
            formData.append('file', file.file); //接口需要传的参数
            this.ajax
                .post("/File/SaveProofPic", formData)
                .then(x => {
                    var imgurl = x.result.data[0];
                    this.curproofpath = imgurl;
                    console.log("打印图片路径:" + x);
                }).catch(() => {
                    this.$toast.fail({
                        message: "上传失败,请重新上传"
                    });
                    this.curproofpath = '';
                });
        },
        //转上级需要凭证
        Recharge() {
            // if (this.fileList.length < 1) {
            //     this.$toast.fail({
            //         title: '提示',
            //         message: '请先提交凭据'
            //     })
            //     return;
            // }
            this.tj(0, this.curitem, this.curproofpath);
        },
        detail(item) {
            this.$router.push({
                name: "subrechargerecorddetail",
                params: item
            });
        },
        formatDate(date) {
            return `${date.getMonth() + 1}/${date.getDate()}`;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;

            this.starttime = start;
            this.endtime = end;
            this.navList.forEach(x => {
                x.loadingType = "refresh";
            });
            this.loadData();
            //将数组重置 并重新执行查询

            //startTime
            //endTime
        },
        onSearch(val) {
            //将数组重置 并重新执行查询
            console.log(val);
            this.iptvalue = val;
            this.navList.forEach(x => {
                x.loadingType = "refresh";
            });
            this.loadData();
        },
        tabchange() {
            this.loadData('tabChange');
        },
        onRefresh() {
            this.loadData('refresh');
        },
        loadData(source) {

            let index = this.tabCurrentIndex;
            let navItem = this.navList[index];
            // let state = navItem.state;

            if (source === 'tabChange' && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }
            if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
                //防止重复加载
                if (source != 'refresh') {
                    return;
                }
            }
            if (source == 'refresh' || navItem.loadingType == 'refresh') {
                this.navList[index].List = [];
                this.navList[index].getparams.skipCount = 0;
                this.navList[index].getparams.startTime = this.starttime;
                this.navList[index].getparams.endtime = this.endtime;
                this.navList[index].getparams.tid = this.iptvalue;
            }
            navItem.loadingType = 'loading';
            var params = navItem.getparams;
            //加载数据
            this.ajax.post('/api/services/app/PhoneUser/QuerySubRechargeRecordPages', params).then(x => {
                this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navList[index].List = this.navList[index].List.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' : 'nomore';
            }).finally(() => {
                this.$set(this.navList[index], 'loaded', false);
                this.refreshing = false;
            });

        },
        // onLoad() {
        //   if (this.refreshing) {
        //     this.list = [];
        //     this.refreshing = false;
        //     this.pageParams.skipCount = 0;
        //   }
        //   this.ajax
        //     .post(
        //       "/api/services/app/PhoneUser/QuerySubRechargeRecordPages",
        //       this.pageParams
        //     )
        //     .then((x) => {
        //       const items = x.result.items;
        //       this.list.push(...x.result.items);
        //       this.pageParams.skipCount += this.pageParams.maxResultCount;
        //       this.totalCount = x.result.totalCount;
        //     })
        //     .finally(() => {
        //       this.loading = false;

        //       if (this.pageParams.skipCount >= this.totalCount) {
        //         this.finished = true;
        //       }
        //     });
        // },
        // onRefresh() {
        //   // 清空列表数据
        //   this.finished = false;

        //   // 重新加载数据
        //   // 将 loading 设置为 true，表示处于加载状态
        //   this.loading = true;
        //   this.onLoad();
        // },
    },
};
</script>

<style lang="scss" scoped>
.mian-list {
    background-color: #fff;
    margin-top: 10px;
    font-size: 12px;
    border-radius: 8px;
    margin: 10px;
    padding: 10px;
    box-shadow: 1px 1px 4px #c3c3c3;
    word-break: break-all;
    line-height: 18px;
}

.mian-list-info {
    padding: 5px 0 5px 110px;
    font-size: 14px;
    position: relative;
    min-height: 100px;
    word-break: break-all;
}

.main-list-info-main {
    position: relative;
}

.min-height {
    min-height: 18px;
    margin-bottom: 10px;
}

.mian-list-info-right {
    position: absolute;
    right: 0;
    width: 90px;
    text-align: right;
}

.mian-list-info-left-tag {
    position: absolute;
    left: 0;
}

.mian-list-info-right-tag {
    position: absolute;
    right: 0;
}

.mian-list-mark {
    border-top: 1px solid #e2e2e2;
    padding-top: 10px;
    font-size: 18px;
}

.mian-list-btns {
    margin-top: 20px;
    text-align: center;
}

.mian-list-btns button {
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}

.mian-list-pic {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100px;
    height: 100px;
    transform: translate(0, -50%);
}

.mian-list-pic img {
    width: 100%;
    height: 100%;
}

.info {
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    margin: 20px 10px 10px 10px;
    font-size: 12px;
    width: 250px;
}

.mz-proof-btns {
    margin-bottom: 10px;
    text-align: center;
}

.mz-proof-btns button {
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}

.mian-list-info-data-last {
    text-align: right;
}
</style><style lang="scss" scoped>
.van-uploader__wrapper {
    width: 100%;
    display: block;
}

.van-uploader__upload {
    width: 100%;
}

.van-uploader {
    display: block;
}

.van-uploader__preview-image {
    width: 100%;
    height: 80px;
}
</style>
